import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import Ad from '@ifeng-fe/ui_pc_ad';
import { Comment } from 'ThreeTerminal_pc_dynamic';
import styles from './index.css';
import ArticleContent from '../../../../components/articleContent';
import SlideArea from '../slideArea';
import SeoSummary from '../../../../components/seoSummary';

class ArticleArea extends React.PureComponent {
    static propTypes = {
        articleData: PropTypes.object,
        pluginData: PropTypes.object,
        commentAd: PropTypes.object,
        commentBottomAd: PropTypes.object,
        type: PropTypes.string,
        articleSummary: PropTypes.string,
    };

    render() {
        const {
            articleData: { commentUrl, skey, pcUrl, allowComment, contentData, title = '' },
            pluginData,
            commentAd,
            commentBottomAd,
            type,
            articleSummary,
        } = this.props;
        const commentDomain =
            typeof window === 'object' && window.allData && window.allData.__cd__
                ? window.allData.__cd__
                : 'c01049em.ifeng.com';
        const commentConfig = {
            docUrl: commentUrl,
            docTitle: title,
            skey,
            speUrl: '',
            pcUrl,
            cmtNumUrl: `//${commentDomain}/get.php`,
            cmtLength: 1000,
            cmtPostUrl: `//${commentDomain}/post.php`,
            hotLimit: 2,
            cmtVoteUrl: `//${commentDomain}/vote.php`,
            replyLimit: 3,
            jubUrl: `//${commentDomain}/report`,
            jubNum: 0,
            isComment: false,
            allowComment,
            order: 'both',
            options: 1,
            recentLimit: 2,
            recentReplyLimit: 3,
        };

        return (
            <div>
                <div className={styles.main_content}>
                    <SeoSummary summary={articleSummary} />
                    {type === 'article' ? <ArticleContent content={contentData} pluginData={pluginData} /> : null}
                    {type === 'slide' ? <SlideArea slideData={contentData} /> : null}
                </div>
                <p className={styles.alarm}>本文来自大风号，仅代表大风号自媒体观点。</p>
                <NoSSR>
                    <Ad content={commentAd} styleName={styles.commentAd} />
                    {allowComment ? (
                        <div className={styles.commentsBox}>
                            <LazyLoad>
                                <Comment articleInfo={commentConfig} />
                            </LazyLoad>
                        </div>
                    ) : null}
                    <Ad content={commentBottomAd} styleName={styles.commentBottomAd} />
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(ArticleArea);
